import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';
import { rootRoute } from '../__root';

const acceptInviteLinkSearchSchema = z.object({
  token: z.string().optional(),
});

export const acceptInviteLinkRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/auth/accept-invite-link',
  validateSearch: acceptInviteLinkSearchSchema,
  component: lazyRouteComponent(
    () => import('@/features/auth/AcceptInviteLinkContent'),
    'AcceptInviteLinkContent',
  ),
});
